<template>
    <div class='main'>
       <div class='main-area'>
           <router-view></router-view>
       </div>
   </div>
</template>

<script setup>
   import { computed, ref, onMounted } from 'vue';
   import { useRouter } from 'vue-router';
   import store from '../store/index.js'

   const rounter = useRouter()

   const SS_Available = computed(() => store.getters.SS_Available)
   const user = computed(() => store.state.user)
   onMounted(() => {
       if (!user.value) {
           rounter.push('/login')
       }
       if (!SS_Available.value) {
           store.dispatch('addNotification', { text: 'Sanction Screaning Module is not available, contact support to get more info', type: 'error' })
           rounter.push('/')
       }
   })
</script>